import { useParams } from "react-router-dom";
import ImageRow from "../components/ImageRow";
import { useSalePage } from "../hooks/useSalePage";

export default function SalePage() {
  const domain = window.location.hostname;
  const { pagePath } = useParams();

  const { data, loading, error } = useSalePage(domain, `/${pagePath || ''}`);

  if (loading) {
    return (
      <div style={styles.loadingContainer}>
        <div className="loader"></div>
        <p style={styles.loadingText}>Loading...</p>
      </div>
    );
  }

  /** ❌ 404 – Page Not Found */
  if (!data || !data.layout) {
    return (
      <div style={styles.notFoundContainer}>
        <h1 style={styles.notFoundCode}>404</h1>
        <p style={styles.notFoundMessage}>Not Found</p>
      </div>
    );
  }

  /** ✅ แสดง Sale Page ปกติ */
  return (
    <div style={styles.pageWrapper}>
      <div style={styles.salePageContainer}>
        {data.layout.map((row) => (
          <ImageRow key={row.rowId} images={row.images} />
        ))}
      </div>
    </div>
  );
}

/** 🎨 CSS in JS (สวยแบบเรียบหรู) */
const styles = {
  pageWrapper: {
    width: "100%",
    minHeight: "100vh",
    background: "#000",  
    display: "flex",
    justifyContent: "center",
  },
  salePageContainer: {
    width: "100%",
    maxWidth: 480,
    background: "#000",
  },

  /** LOADING */
  loadingContainer: {
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    color: "#fff",
    background: "#000",
  },
  loadingText: {
    marginTop: 15,
    fontSize: 18,
    opacity: 0.7,
  },

  /** 404 */
  notFoundContainer: {
    height: "100vh",
    background: "#000",
    color: "#fff",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    padding: 20,
  },
  notFoundCode: {
    fontSize: "80px",
    fontWeight: "bold",
    marginBottom: 10,
    color: "#ff4d4d",
  },
  notFoundMessage: {
    fontSize: "20px",
    opacity: 0.8,
  },
  backButton: {
    marginTop: 25,
    padding: "10px 20px",
    background: "#ff4d4d",
    color: "#fff",
    borderRadius: 8,
    textDecoration: "none",
    fontWeight: "bold",
  },
};
